import { assignCommonProperties } from '../../util/data/assign-common-properties.js'

import { TsTypeType } from '../../types.js'
import {
	jsonProperty,
	jsonClass,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'

export const EventHandlerTypes = {
	adhoc: 'Ad-hoc action',
	central: 'Centrally-managed action',
} as const
export type EventHandlerType = keyof typeof EventHandlerTypes

@jsonClass('EventHandler')
export class EventHandler {
	@jsonProperty(String)
	eventName!: string
	@jsonProperty(String)
	eventPrefix?: string

	@jsonProperty(String)
	description?: string

	@jsonProperty(String)
	type: EventHandlerType = 'adhoc'

	@jsonProperty(String)
	actionName!: string

	@jsonProperty(String)
	adHocCode?: string
	
	overrideHtmlEventCode?: string

	@jsonMapProperty(String, String)
	parameterAssignments: Map<string, TsTypeType> = new Map()

	constructor(init?: Partial<EventHandler>) {
		assignCommonProperties(this, init)
	}
}
